module.exports = __webpack_public_path__ + "img/招标采购全过程审计.fcbd1c7f.png";